import rigshospitaletImage from "../images/tracheostomy.jpg";
import novoImage from "../images/Novo.jpg";
import virsabiImage from "../images/virsabi.jpg";
import lionImage from "../images/lions.jpg";
import spaceFighterImage from "../images/spaceFighter.jpg";


const INFO = {
	main: {
		title: "Portfolio by Lasse V.",
		name: "Lasse Viking",
		email: "LasseVikingKristensen@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		linkedin: "https://www.linkedin.com/in/lasseviking/",
	},

	homepage: {
		title: "I create immersive interactive experiences.",
		description:
			"Hi, my name is Lasse, and welcome to my portfolio.",
	},

	about: {
		title: "I'm Lasse Viking and I design immersive interactive experiences.",
		description:
		[
			"I like working on different projects in my spare time such as development of VR, AR, web, music, games, and videos.",
			 "One of my biggest passions when making software is creating interactive experiences that offer value to the user both inside and outside the experience.", 
			 "I also believe that in no matter what you engage, you learn something, and that learning outcome can be designed and iterated upon based on desired outcome.",
		]	
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what immersive technologies can bring.",
		description:
			"Chronological collection of some of my reports and papers from university.",
	},

	projects: [
		{
			title: "Master thesis with Rigshospitalet",
			description:
				"For the master we built a VR training experience that lets nurses safely practice tracheostomy care before performing the procedure on patients. Designed to make training more engaging, accessible, and repeatable.",
			logo: rigshospitaletImage,
			linkText: "View Project",
			link: "https://drive.google.com/drive/folders/1-cqT_tKes0px4WviT4ShVjG8k1LdwxAu?usp=sharing",
		},
		{
			title: "Internship with Novo Nordisk",
			description:
				"I developed an AR navigation app that aimed helps laboratory staff quickly find sample collection locations to reduce clinical errors and reduce time. The solution was built for secure lab environments using QR-based localization.",
			logo: novoImage,
			linkText: "View Project",
			link: "https://drive.google.com/drive/folders/1-cqT_tKes0px4WviT4ShVjG8k1LdwxAu?usp=sharing",
		},
		{
			title: "Bachelor project with Virsabi",
			description:
				"I created a VR experience that lets students step aboard a container ship and explore careers in the maritime industry. The project focused on using immersion to spark curiosity and engagement, and use scale to create wow effect.",
			logo: virsabiImage,
			linkText: "View Project",
			link: "https://drive.google.com/drive/folders/1-cqT_tKes0px4WviT4ShVjG8k1LdwxAu?usp=sharing",
		},
		{
			title: "Semester project with Lions Neurocenter",
			description:
				"We designed a VR experience for people with acquired brain injuries, helping support cognitive and physical stimulation through playful physical interactions and music. Developed in close collaboration with residents and healthcare staff at Lions Neurocenter.",
			logo: lionImage,
			linkText: "View Project",
			link: "https://drive.google.com/drive/folders/1-cqT_tKes0px4WviT4ShVjG8k1LdwxAu?usp=sharing",
		},
		{
			title: "University VR course game",
			description:
				"I Built a VR space shooter for a VR course to explore cybersickness limits, interaction design, immersive UI, multiplayer, and voice recognition. Focused on creating responsive gameplay and an engaging VR experience with some lightweight AI and multiplayer action for up to 6 players.",
			logo: spaceFighterImage,
			linkText: "View Project",
			link: "",
		},
	],
};

export default INFO;
